<template>
    <div>
        <show-messages the-type="image"></show-messages>
    </div>
</template>

<script>
import ShowMessages from '@/components/ShowMessages.vue'

export default {
    name: 'gallery',
    components: {
        ShowMessages
    }
}
</script>